export default __webpack_public_path__ + "static/media/56ec03b0c0c36ef75b64c7e285c8df011579271195720.1fbefda2.webp";